import React, { useEffect } from 'react';
import { styled } from '@linaria/react';
import { cssTheme } from '@daedalus/atlas/themes';
interface Props {
  /** The language in which the widget should render */
  lang?: string;
  /** Widget variant to use
   * https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-widget-overview#mini-8
   */
  variant?: 'default' | 'mini' | 'horizontal';
  theme?: 'light' | 'dark';
}
export const TrustPilotWrapper = /*#__PURE__*/styled('div')({
  name: "TrustPilotWrapper",
  class: "tvvh18k",
  propsAsIs: false
});
export const TrustpilotWidget = ({
  lang = 'en',
  variant = 'default',
  theme: widgetTheme = 'light'
}: Props) => {
  const WIDGET_PARAMS_MAP = {
    default: {
      templateId: '5419b732fbfb950b10de65e5',
      height: '20',
      width: '100%',
      color: cssTheme.colors.content.neutral.c950
    },
    mini: {
      templateId: '53aa8807dec7e10d38f59f32',
      height: '90px',
      width: '144px',
      color: undefined
    },
    horizontal: {
      templateId: '5406e65db0d04a09e042d5fc',
      height: '28px',
      width: '250px',
      color: undefined
    }
  };
  useEffect(() => {
    const trustbox = document.querySelector('#trustbox');
    const loadHandler = () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(trustbox);
      }
    };
    let aScript: HTMLScriptElement;
    if (window.Trustpilot) {
      loadHandler();
    } else {
      aScript = document.createElement('script');
      aScript.type = 'text/javascript';
      aScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      aScript.async = true;
      document.head.append(aScript);
      aScript.addEventListener('load', loadHandler);
    }
    return () => {
      if (aScript) {
        aScript.removeEventListener('load', loadHandler);
      }
    };
  }, []);
  const {
    templateId,
    height,
    width,
    color
  } = WIDGET_PARAMS_MAP[variant];
  return <TrustPilotWrapper id="trustbox" className="trustpilot-widget chromatic-ignore" data-locale={lang} data-businessunit-id="634e76254b89780068df60cd" data-template-id={templateId} data-style-height={height} data-style-width={width} data-theme={widgetTheme} data-text-color={color} data-text-align="center">
      <a href="https://www.trustpilot.com/review/vio.com" target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </TrustPilotWrapper>;
};

require("./TrustpilotWidget.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TrustpilotWidget.tsx");